import { render, staticRenderFns } from "./copy-section-connect.vue?vue&type=template&id=18f04d13&"
import script from "./copy-section-connect.vue?vue&type=script&lang=js&"
export * from "./copy-section-connect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports